import {Checkbox} from 'platform/components';
import {VStack} from 'platform/foundation';

import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {MoneyInputField} from './MoneyInputField';

interface LeasingIncludableCostProps {
  label: string;
  included: boolean;
  amount: SaveSaleVehicleLeasingBody['commonParameters']['vehicleTransferAmount'];
  currency: string;
  isReadOnly: boolean;
  onIncludedChange: (value: boolean) => void;
  onAmountChange: (
    value: SaveSaleVehicleLeasingBody['commonParameters']['vehicleTransferAmount']
  ) => void;
}

/** One one-time leasing cost: its amount input plus the "included in offer" toggle. */
export function LeasingIncludableCost(props: LeasingIncludableCostProps) {
  return (
    <VStack spacing={2}>
      <MoneyInputField
        label={props.label}
        value={props.amount}
        currency={props.currency}
        isDisabled={props.isReadOnly}
        onChange={props.onAmountChange}
      />
      <Checkbox
        label={i18n.t('page.vehicle.financingAndLeasing.included', {item: props.label})}
        helperText={i18n.t('page.vehicle.financingAndLeasing.includedCostHint')}
        value={props.included}
        isDisabled={props.isReadOnly}
        onChange={props.onIncludedChange}
      />
    </VStack>
  );
}
